import { isValidPhoneNumber } from "react-phone-number-input";
import {
  getNameValidationError,
  getOptionalPersonalIdentityNumberValidationError,
  getPhoneValidationError,
  hasValue,
  isValidName,
  isValidOptionalPersonalIdentityNumber,
} from "../shared/staffInputValidation.logic";
import type { StampClockRegistrationFormData } from "./stampClockRegistration.contract";

export type StampClockRegistrationFieldErrors = Readonly<
  Record<
    "firstName" | "lastName" | "personalIdentityNumber" | "phoneNumber",
    string | null
  >
>;

export const getStampClockRegistrationFormFieldErrors = (
  formData: StampClockRegistrationFormData,
): StampClockRegistrationFieldErrors => ({
  firstName:
    getNameValidationError({ field: "firstName", value: formData.firstName })
      ?.translationKey ?? null,
  lastName:
    getNameValidationError({ field: "lastName", value: formData.lastName })
      ?.translationKey ?? null,
  personalIdentityNumber:
    getOptionalPersonalIdentityNumberValidationError(
      formData.personalIdentityNumber,
    )?.translationKey ?? null,
  phoneNumber:
    getPhoneValidationError(formData.phoneNumber)?.translationKey ?? null,
});

export const isStampClockRegistrationFormComplete = ({
  formData,
  teamId,
}: {
  readonly formData: StampClockRegistrationFormData;
  readonly teamId: string;
}): boolean =>
  isValidPhoneNumber(formData.phoneNumber) &&
  hasValue(formData.personalIdentityNumber) &&
  isValidOptionalPersonalIdentityNumber(formData.personalIdentityNumber) &&
  isValidName(formData.firstName) &&
  isValidName(formData.lastName) &&
  hasValue(teamId);
